import * as React from "react";
import { cn } from "../lib/cn";

export function Skeleton({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-bg-overlay", className)}
      {...props}
    />
  );
}
